<script setup>
import { onMounted, ref } from "vue";
import Basket from "./Basket.vue";
import http from './http.js';

const show = ref(window.show)
const open = ref(false)
const basket = ref({
    items:[],
    voucher:{}
})
const loading = ref(false)
const step = ref(1)

onMounted(async ()=>{
    let r = await http.get('cart');

    console.log(r.data)

    if(r.data){
        basket.value = r.data;
        basket.value.items = Object.values(basket.value.items ?? [])
    }

    if(window.location.hash){
        let hsh = window.location.hash.substring(1);
        if(hsh=='tickets'){
            open.value = true
            step.value = 1
            document.getElementById('tickets').scrollIntoView({ behavior: 'smooth' }); 
        }else if(hsh=='basket'){
            open.value = true
            step.value = 2
            document.getElementById('tickets').scrollIntoView({ behavior: 'smooth' });

            if(basket.value.items.length == 0){
                pageBack()
            }
        }
    }

})

const basketCount = (s=null)=>{
    let lst = null

    if(!basket.value.items) return 0

    if(s){
        lst = basket.value.items.filter((el)=>{
            return el.model_id == s.id
        })
    }else{
        lst = basket.value.items
    }

    if(!lst || !lst.length) return 0

    let cnt = lst.reduce((a, b)=>{
        return a + b.qty;
    }, 0);

    return cnt
}

const basketPrice = (s=null)=>{
    let lst = null

    if(s){
        lst = basket.value.items.filter((el)=>{
            return el.model_id == s.id
        })
    }else{
        lst = basket.value.items
    }

    if(!lst || !lst.length) return 0

    let cnt = lst.reduce((a, b)=>{
        return a + b.price*b.qty;
    }, 0);

    return cnt
}

const add = (s)=>{
    if(!basket.value.items){
        basket.value.items = []
    }

    let existing = basket.value.items.filter((el)=>{
        return el.model_id == s.id
    });

    if(existing.length){
        if(s.tickets_left <= existing[0].qty || existing[0].qty >= 12){
            return
        }
        existing[0].qty++
    }else{
        if(s.tickets_left == 0){
            return
        }

        basket.value.items.push({
            model_type:'App\\Models\\SubShow',
            model_id:s.id,
            qty:1,
            price:s.price
        })
    }
}

const remove = (s)=>{
    let existing = basket.value.items.filter((el)=>{
        return el.model_id == s.id
    });

    if(existing.length){
        if(existing[0].qty > 1)
        {
            existing[0].qty--
        }else{

            basket.value.items = basket.value.items.filter((el)=>{
                return el.model_id != s.id
            })
        }
    }

    if(basket.value.items.length == 0){
        update()
    }
}

const update = async ()=>{
    if(loading.value) return

    loading.value = true;
    try{
        let b = await http.post('cart',basket.value); 
        basket.value = b.data;
        basket.value.items = Object.values(basket.value.items ?? [])
    }catch(err){
      //make alert with below text!!
      console.log(err.response.data.message);      
    }
    
    // Cancel going to basket here pls
    loading.value = false
}

const clear = async ()=>{
    basket.value = {items:[],voucher:{}};
    update()
}

const stepTwo = async ()=>{
    if(!basket.value.items || basket.value.items.length==0) return

    await update()
    // Let people come back to the cart when pressing back
    // window.location.replace('#tickets')
    // window.location.assign('/winkelmand')
    step.value = 2
    window.location.assign('#basket')
}

const openTickets = ()=>{
    if(open.value == true){
        open.value = false
    }else{
        open.value = true
        window.location.replace('#tickets')
    }
}

const pageBack = ()=>{
    step.value = 1
    window.location.replace('#tickets')
}

</script>

<template>
    <div v-if="show && show.sub_shows && show.sub_shows.length" ref="container">
        <div class="flex flex-row justify-end mb-2 ml-4">
            <a href="#" @click.prevent="openTickets" class="btn btn-primary disabled" v-if="show.status=='cancelled'">Geannuleerd <i class="icon icon-arrow-down text-sm ml-1"></i></a>
            <a href="#" @click.prevent="openTickets" class="btn btn-primary disabled" v-else-if="show.is_past">Tickets <i class="icon icon-arrow-down text-sm ml-1"></i></a>
            <a href="#" @click.prevent="openTickets" class="btn btn-primary" v-else>Tickets <i class="icon icon-arrow-down text-sm ml-1"></i></a>
        </div>
        <div  v-if="open">
            <div class="rounded-xl overflow-hidden mb-4 flex flex-col" v-if="step==1">
                <div class="p-4 flex flex-row items-center bg-facet-green text-light" v-if="basket.voucher && basket.voucher.show_id == show.id">
                    <i class="icon icon-present text-xl text-light mr-4"></i>
                    <p class="text-lg">
                        Uw voucher is geactivieerd, u heeft {{ basket.voucher.amount ?? 1 }} vrijkaart{{basket.voucher.amount ?? 1 > 1 ? 'en':''}}!
                    </p>
                </div>
                <div class="bg-dark-accent flex flex-col sm:flex-row sm:flex-wrap p-6 gap-6">
                    <div class="rounded-xl shadow-lg flex flex-col p-4 bg-light" v-for="sshow in show.sub_shows" :key="sshow.id">
                        <h2 class="text-lg font-semibold text-dark">{{ sshow.start_date_string ?? 'Onbekende Datum'}}</h2>
                        <p class="font-light text-dark">{{sshow.start_time_string ?? 'Onbekende Tijd'}}</p>
                        <p class="font-light text-dark my-2">
                            <span class="text-facet-red"><i class="icon icon-location-pin"></i></span>
                            <span v-if="sshow.location">
                                {{sshow.location.name}}                                     
                            </span>
                            <span v-else-if="show.location">
                                {{show.location.name}}
                            </span>
                            <span v-else>
                                Onbekend
                            </span>
                        </p>
                        <p class="text-green-700 font-light text-sm" v-if="sshow.tickets_left > 20">Voldoende plaatsen</p>
                        <p class="text-orange-700 font-light text-sm" v-else-if="sshow.tickets_left > 12">Beperkt plaats</p>
                        <p class="text-red-700 font-light text-sm" v-else>Nog {{ sshow.tickets_left }} plaatsen</p>

                        <p class="text-dark font-medium my-2">€ {{sshow.price}}</p>
    
                        <div class="w-full">
                            <div v-if="sshow.state=='cancelled'" class="flex flex-row justify-between">
                                <p class="text-gray-400 uppercase font-medium text-center">Geannuleerd</p>
                            </div>
                            <div v-else-if="sshow.is_past" class="flex flex-row justify-between">
                                <p class="text-gray-400 uppercase font-medium text-center">Geweest</p>
                            </div>
                            <div v-else-if="sshow.tickets_left == 0" class="flex flex-row justify-between">
                                <p class="text-gray-400 uppercase font-medium text-center">Uitverkocht</p>
                            </div>
                            <div v-else-if="Date.parse(show.start_ticket_sale) > Date.now()" class="flex flex-row justify-between">
                                <p class="text-gray-400 uppercase font-medium text-center">Binnenkort!</p>
                            </div>
                            <div v-else-if="sshow.booking_url" class="flex flex-row justify-between items-center">
                                <p class="text-dark uppercase font-medium text-center text-lg mx-2">€ {{ sshow.price }}</p>
                                <a :href="sshow.booking_url" class="btn btn-primary my-auto text-center w-full" target="_blank">
                                    Bestel <i class="icon icon-share-alt ml-1"></i>
                                </a>
                            </div>
                            <div v-else class="flex flex-row justify-between items-center">
                                <div v-if="basketCount(sshow)" class="w-full flex flex-row rounded-tl-xl rounded-br-xl text-lg lg:text-xl font-worksans font-semibold overflow-hidden">
                                    <a href="#" class="w-1/3 p-4 text-dark px-4 bg-slate-300 flex items-center justify-center" @click.prevent="remove(sshow)" >
                                        <i class="icon icon-minus"></i>
                                    </a>
                                    <span class="w-1/3 p-4 text-primary bg-slate-200 flex items-center justify-center">
                                        {{ basketCount(sshow) }}
                                    </span>
                                    <a href="#" class="w-1/3 p-4 text-dark px-4 bg-slate-300 flex items-center justify-center" @click.prevent="add(sshow)">
                                        <i class="icon icon-plus"></i>
                                    </a>
                                </div>
                                <a href="#" class="btn btn-primary text-center w-full" @click.prevent="add(sshow)" v-else>
                                    Bestel
                                    <i class="icon icon-basket ml-1"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex flex-row justify-between sm:justify-end p-4 bg-light rounded-b-xl items-center" v-if="Date.parse(show.start_ticket_sale) < Date.now()">
                    <p class="text-dark font-semibold text-lg mr-8" v-if="step==1">
                        Totaal: 
                        <span class="hidden sm:inline">
                            {{ basketCount() }} Item(s) 
                        </span> 
                        <span v-if="basket.voucher && basket.voucher.value && basketPrice()" class="bg-facet-green text-white rounded-md p-2 font-normal text-md mx-2">
                            <i class="icon icon-present text-white mr-1"></i>
                            -€{{ Math.min(basket.voucher.value,basketPrice()) }}
                        </span>
                        € {{ basket.voucher && basket.voucher.value ? Math.max(basketPrice() - basket.voucher.value, 0): basketPrice()}}
                    </p>
                    <a href="#" class="btn btn-primary relative" :class="{'disabled':!basket.items || basket.items.length==0}" @click.prevent="stepTwo()" v-if="step==1">
                        <span :class="loading?'opacity-0':'opacity-100'">
                            <span class="hidden sm:inline">Naar de</span> Kassa!
                        </span>
                        <span class="absolute w-full h-full flex justify-center items-center top-0 left-0" v-show="loading">
                            <i class="icon icon-settings animate-spin text-inherit"></i>
                        </span>
                    </a>
                </div>
                <div v-else class="flex flex-row justify-between sm:justify-end p-4 bg-light rounded-b-xl items-center">
                    <p class="text-dark font-semibold text-lg mr-8">De Kaartverkoop Start Binnenkort!</p>
                    <a href="#" class="btn btn-primary relative" :class="{'disabled':!basket.items || basket.items.length==0}" @click.prevent="stepTwo()" v-if="step==1">
                        <span :class="loading?'opacity-0':'opacity-100'">
                            <span class="hidden sm:inline">Naar de</span> Kassa!
                        </span>
                        <span class="absolute w-full h-full flex justify-center items-center top-0 left-0" v-show="loading">
                            <i class="icon icon-settings animate-spin text-inherit"></i>
                        </span>
                    </a>
                </div>
            </div>
            <Basket v-else-if="step==2" @back="pageBack()" :cancel-possible="true"></Basket>
        </div>
    </div>
</template>